import { mapValues } from 'lodash/fp';
import type AdminLink from '../../../../../types/AdminLink';
import { useWarningsMuter } from '../../../hooks/useWarningMuter';
import { simpleHash } from '../../../services/simpleHash';
import type { LinkCategories } from './service';

const isSuggestion = (link: AdminLink) => link.enabled && link.status === 'SUGGESTION';

const toId = (link: AdminLink) => `admin-suggestion-${simpleHash(link.name + link.tooltip).toString(36)}`;

export function useMutedSuggestions(categories: LinkCategories) {
    const { isMuted } = useWarningsMuter({ expirationDays: 31 });

    const isMutedSuggestion = (link: AdminLink) => isSuggestion(link) && isMuted(toId(link));
    const clearMutedStatus = (link: AdminLink) => (isMutedSuggestion(link) ? { ...link, status: undefined } : link);

    return {
        categories: mapValues(links => links.map(clearMutedStatus), categories),
        suggestions: Object.values(categories)
            .flat()
            .filter(isSuggestion)
            .map(link => ({ id: toId(link), title: link.name, content: link.tooltip })),
    };
}
